const WALKTHROUGH_VIDEO_ATTRIBUTE = "data-walkthrough-video";

/**
 * Walkthrough videos are mounted by separate components (inline players and
 * dialogs), so they coordinate through the document: when one starts, every
 * other walkthrough <video> still in the DOM is paused. Pausing keeps the
 * position and the native controls, so a viewer can resume it.
 *
 * Wire it to a player with `{...walkthroughVideoProps}`.
 *
 * @param {HTMLVideoElement} playing the video that just fired `play`
 */
function pauseOtherWalkthroughVideos(playing) {
  const videos = document.querySelectorAll(`video[${WALKTHROUGH_VIDEO_ATTRIBUTE}]`);
  for (const video of videos) {
    if (video !== playing) video.pause();
  }
}

export const walkthroughVideoProps = {
  [WALKTHROUGH_VIDEO_ATTRIBUTE]: "",
  onPlay: (event) => pauseOtherWalkthroughVideos(event.currentTarget),
};
